import React, { useState } from "react";
import { Link, NavLink, useNavigate } from "react-router-dom";
import { Menu, X, Phone, User } from "lucide-react";
import Logo from "./Logo";
import { useAuth } from "../../context/AuthContext";

const links = [
  { to: "/", label: "Home" },
  { to: "/services", label: "Services" },
  { to: "/geofencing-101", label: "Geofencing 101" },
  { to: "/case-studies", label: "Case Studies" },
  { to: "/campaign-builder", label: "Start a Campaign" },
  { to: "/about", label: "About" },
  { to: "/contact", label: "Contact" },
];

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  return (
    <header
      className="fixed top-0 left-0 right-0 z-50 backdrop-blur-xl bg-[#0b0b0b]/80 border-b border-[#d4af37]/10"
      data-testid="site-navbar"
    >
      <div className="max-w-[1440px] mx-auto px-6 md:px-10 h-[78px] flex items-center justify-between">
        <Link to="/" data-testid="nav-logo-link">
          <Logo />
        </Link>

        <nav className="hidden xl:flex items-center gap-7">
          {links.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              end={l.to === "/"}
              className={({ isActive }) => `nav-link ${isActive ? "active" : ""}`}
              data-testid={`nav-link-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
            >
              {l.label}
            </NavLink>
          ))}
        </nav>

        <div className="hidden xl:flex items-center gap-6">
          {user ? (
            <button
              onClick={() => navigate("/portal")}
              className="nav-link flex items-center gap-2"
              data-testid="nav-portal-btn"
            >
              <User size={14} strokeWidth={1.5} /> Portal
            </button>
          ) : (
            <Link to="/login" className="nav-link flex items-center gap-2" data-testid="nav-login-btn">
              <User size={14} strokeWidth={1.5} /> Log In
            </Link>
          )}
          <a
            href="tel:2533318487"
            className="flex items-center gap-2 text-[#d4af37] tracking-widest text-[12px]"
            data-testid="nav-phone-link"
          >
            <Phone size={14} strokeWidth={1.5} /> 253-331-8487
          </a>
        </div>

        <button
          className="xl:hidden text-white"
          onClick={() => setOpen((o) => !o)}
          aria-label="Toggle menu"
          data-testid="mobile-menu-toggle"
        >
          {open ? <X size={22} /> : <Menu size={22} />}
        </button>
      </div>

      {open && (
        <div className="xl:hidden bg-[#0b0b0b] border-t border-[#d4af37]/10" data-testid="mobile-menu">
          <div className="px-6 py-6 flex flex-col gap-5">
            {links.map((l) => (
              <NavLink
                key={l.to}
                to={l.to}
                end={l.to === "/"}
                onClick={() => setOpen(false)}
                className={({ isActive }) => `nav-link ${isActive ? "active" : ""}`}
                data-testid={`mobile-link-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
              >
                {l.label}
              </NavLink>
            ))}
            {user ? (
              <>
                <button onClick={() => { setOpen(false); navigate("/portal"); }} className="nav-link text-left" data-testid="mobile-portal-btn">Portal</button>
                <button onClick={() => { logout(); setOpen(false); }} className="nav-link text-left" data-testid="mobile-logout-btn">Log Out</button>
              </>
            ) : (
              <Link to="/login" onClick={() => setOpen(false)} className="nav-link" data-testid="mobile-login-btn">Log In</Link>
            )}
            <a href="tel:2533318487" className="text-[#d4af37] tracking-widest text-[12px]" data-testid="mobile-phone-link">
              253-331-8487
            </a>
          </div>
        </div>
      )}
    </header>
  );
}
